/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import React, {
    useCallback,
    useContext
} from 'react';
import PropTypes from 'prop-types';
import { useModal } from '@jutro/components';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { FormModalPopover } from 'ml-components-platform-react';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import modalPopoverUi from './MLHOHobbyFarmScheduledItemsPopover.metadata.json5';
import metadata from './MLHOHobbyFarmScheduledItemsComponent.metadata.json5';
import messages from './MLHOHobbyFarmScheduledItemsComponent.messages';

const HOBBY_FARM_ITEM_TYPE = 'hobbyFarmScheduledItems';
const HOBBY_FARM_DTO_PATH = 'metlife.edge.capabilities.common.plugin.dto.HOPHobbyFarmCovScheduledItemDTOML';


function MLHOHobbyFarmScheduledItemsComponent(props) {
    const modalApi = useModal();
    const {
        items,
        defaultItem,
        readOnly,
        loading,
        parentAddItemSaveHandler,
        parentEditItemSaveHandler,
        parentRemoveItemHandler,
        addressFormatter,
        resetChosenTermAndChosenTermValue,
        formatOptionAvailableVals
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);

    const editItemSaveHandler = useCallback((vm) => {
        return parentEditItemSaveHandler(vm, HOBBY_FARM_ITEM_TYPE);
    }, [parentEditItemSaveHandler]);

    const addItemSaveHandler = useCallback((vm) => {
        return parentAddItemSaveHandler(vm, HOBBY_FARM_ITEM_TYPE);
    }, [parentAddItemSaveHandler]);

    const getPopupProps = useCallback((vm, isEdit) => {
        return {
            title: messages.modalTitle,
            uiProps: modalPopoverUi.pageContent,
            actionBtnLabel: messages.continueBtn,
            viewModel: vm,
            getOverrideProps: () => {
                return {
                    publicAccessDropdownSelect: {
                        value: vm.publicAccess.chosenTerm.value,
                        availableValues: formatOptionAvailableVals(vm.publicAccess.options.value),
                        validationMessages: vm.publicAccess.chosenTerm.aspects.validationMessages
                    },
                    rentedOrLeasedDropdownSelect: {
                        value: vm.rentedOrLeased.chosenTerm.value,
                        availableValues: formatOptionAvailableVals(vm.rentedOrLeased.options.value),
                        validationMessages: vm.rentedOrLeased.chosenTerm.aspects.validationMessages
                    },
                    isADwellingOnLandDropdownSelect: {
                        value: vm.isADwellingOnLand.chosenTerm.value,
                        availableValues: formatOptionAvailableVals(vm.isADwellingOnLand.options.value),
                        validationMessages: vm.isADwellingOnLand.chosenTerm.aspects.validationMessages
                    }
                };
            },
            onSaveAction: isEdit ? editItemSaveHandler : addItemSaveHandler
        };
    }, [addItemSaveHandler, editItemSaveHandler, formatOptionAvailableVals]);

    const getDefaultScheduleItem = useCallback(() => {
        const defaultHobbyFarm = resetChosenTermAndChosenTermValue(defaultItem);
        return _.omit(defaultHobbyFarm, ['fixedID', 'addressLine1', 'city', 'description', 'state', 'zipCode']);
    }, [defaultItem, resetChosenTermAndChosenTermValue]);

    const onAddItem = useCallback(() => {
        const isEdit = false;
        const defaultVal = getDefaultScheduleItem();
        const vm = viewModelService.create(defaultVal, 'pc', HOBBY_FARM_DTO_PATH);
        const componentProps = getPopupProps(vm, isEdit);

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [getDefaultScheduleItem, getPopupProps, viewModelService]);

    const onEditItem = useCallback((evt) => {
        const isEdit = true;
        const selectedItem = items[evt.index];
        const selectedItemVm = viewModelService.create(selectedItem, 'pc', HOBBY_FARM_DTO_PATH);
        const componentProps = getPopupProps(selectedItemVm, isEdit);

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [getPopupProps, items, viewModelService]);

    const onRemoveItem = useCallback((evt) => {
        parentRemoveItemHandler(evt.index, HOBBY_FARM_ITEM_TYPE);
    }, [parentRemoveItemHandler]);

    const generateItemOverrides = useCallback(() => {
        const itemOverrides = items.map((item, itemIndex) => {
            return {
                [`actionRow${itemIndex}`]: {
                    visible: !readOnly,
                    className: loading ? 'cell disabled' : 'cell'
                },
                [`addressContent${itemIndex}`]: {
                    content: addressFormatter(item)
                }
            };
        });

        return Object.assign({}, ...itemOverrides);
    }, [addressFormatter, items, loading, readOnly]);

    const overrides = {
        stackTableDiv: {
            className: readOnly ? 'stack-table' : 'stack-table plain'
        },
        actionHeader: {
            visible: !readOnly
        },
        tableRowIterable: {
            data: items
        },
        bottomButtonContainer: {
            visible: !readOnly
        },
        addItemBtn: {
            visible: !readOnly,
            disabled: loading
        },
        ...generateItemOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onAddItem,
            onEditItem,
            onRemoveItem
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLHOHobbyFarmScheduledItemsComponent.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
    defaultItem: PropTypes.shape({}),
    readOnly: PropTypes.bool,
    loading: PropTypes.bool,
    parentAddItemSaveHandler: PropTypes.func,
    parentEditItemSaveHandler: PropTypes.func,
    parentRemoveItemHandler: PropTypes.func,
    addressFormatter: PropTypes.func,
    resetChosenTermAndChosenTermValue: PropTypes.func
};

export default MLHOHobbyFarmScheduledItemsComponent;